import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HeaderTemplateData } from '../dialog-data.interface';

interface filterDailog {
    header: HeaderTemplateData
    filterType: String
}

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'tenant-sales-filter-dialog',
    templateUrl: './tenant-sales-filter-dialog.html'
})

// tslint:disable-next-line: component-class-suffix
export class TenantSalesFilterDialog implements OnInit {
    header:HeaderTemplateData;
    result:String;
    form: FormGroup;

    constructor(
        private _dialogRef: MatDialogRef<TenantSalesFilterDialog>,
        private _fb: FormBuilder,

        @Inject(MAT_DIALOG_DATA) private _data: filterDailog,
    ) {
        if(_data){
            this.header = _data.header;
            this.result = _data.filterType;
        }
    }

    ngOnInit() {
        this.form = this._fb.group({
            filterParam: ['0']
        });
    }

    onSelection() {
        this._dialogRef.close(this.form.controls['filterParam'].value);
    }

    reset() {
        this.form.get("filterParam").setValue('0');
    }
}
